import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from "@apollo/client/core";

import authLink from "../auth/authLink";

export default new ApolloClient(
    {
        cache: new InMemoryCache(
            {
                typePolicies: {
                    ProductSearch: {
                        fields: {
                            results: {
                                keyArgs: false,
                                merge(existing, incoming) {
                                    if (!existing) return incoming;

                                    const nodes = [
                                        ...existing.nodes,
                                        ...incoming.nodes,
                                    ].filter(
                                        (e, i, a) => a.findIndex(
                                            (x) => x.__ref === e.__ref
                                        ) === i
                                    );

                                    return {
                                        ...incoming,
                                        nodes,
                                    };
                                },
                            },
                        },
                    },
                },
            }
        ),
        link: ApolloLink.from([authLink(), new HttpLink({ uri: "https://api.bimproject.cloud/graphql" })]),
    },
);
